import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AboutInfoComponent } from './about-info.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { FreightComponent } from './freight/freight.component';
import { InvestorsComponent } from './investors/investors.component';
import { NewsComponent } from './news/news.component';
import { VendorsComponent } from './vendors/vendors.component';

const routes: Routes = [
  {
    path: 'aboutInfo',
    component: AboutInfoComponent,
    children: [
      { path: 'aboutus', component: AboutUsComponent },
      { path: 'contactus', component: ContactUsComponent },
      { path: 'freight', component: FreightComponent },
      { path: 'investors', component: InvestorsComponent },
      { path: 'news', component: NewsComponent },
      { path: 'vendors', component: VendorsComponent }
    ]
  },
  {
    path: 'about',
    redirectTo: '/aboutInfo',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AboutInfoRoutingModule {}
